import React, { useState } from 'react';
import Information from './Information';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import FormGroup from '@mui/material/FormGroup';
import EmailInput from './EmailInput';

const LandingPage = ({ onNext, evaluation, inputChange }) => {
  
  const [emailErrorCheck, setEmailErrorCheck] = useState(true);

  const handleEmailCheck = (emailError) => {
    setEmailErrorCheck(emailError);
  }
  return (
    <section>
      <div className="container">
        <div className="wrapper">
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <img width="100" src="/img/logo512.png" alt="Digitorum Flex Logo" />
          </div>
          <h1 style={{ marginTop: '0px' }}>Digitorum Flex</h1>
          <br></br>
          <hr></hr>
          <br></br>
          <h2>Thank you for your recent application to Digitorum Flex.</h2>
          <h2>We have designed a few questions for you.</h2>
          <br></br>
          <hr></hr>
          <br></br>
          <p>The following 4 sets of questions serve as a tool to efficiently communicate your specific skill set in the General, Mechanical, Electrical and Software work topics.</p>
          <p>We kindly request that you answer truthfully and as accurately as possible. Any overestimation of your skills could result in undesired short-term outcomes should you be unable to perform the required tasks.</p>
          <p>We are in a recruitment phase at the junior, mid, and senior level. We require a variety of different individual skills in the mechanical, electrical and software fields.</p>
          <p>These questions aim to assist both you and the company in finding your best possible fit within the organization. An honest and accurate assessment of your skills offers a higher likelihood of a successful application and, in turn, an opportunity for growth.</p>
          <br></br>
          <hr></hr>
          <br></br>
          <Box display="block" justifyContent="center">
            <FormGroup>
              <Box display="flex" paddingTop={2} justifyContent="center">
                <Information number={0} question={"First Name "} type={"text"} title={"Name"} inputChange={inputChange} currentValue={evaluation["Name"]} />
                <Information number={1} question={"Last Name "} type={"text"} title={"Surname"} inputChange={inputChange} currentValue={evaluation["Surname"]} />
              </Box>
            </FormGroup>
            <FormGroup>
              <Box display="flex" paddingTop={2} justifyContent="center">
                <Information number={2} question={"Age"} type={"text"} title={"Age"} inputChange={inputChange} currentValue={evaluation["Age"]} />
                <Information number={3} question={"Gender"} type={"text"} title={"Gender"} inputChange={inputChange} currentValue={evaluation["Gender"]} />
              </Box>
            </FormGroup>
            <FormGroup>
              <Box display="grid" paddingTop={2} justifyContent="center">
                <EmailInput number={4} question={"Email "} inputChange={inputChange} currentValue={evaluation["Email"]} emailCheck={handleEmailCheck} />
              </Box>
              <Box display="grid" paddingTop={2} justifyContent="center">
                <Information number={5} question={"Qualification"} type={"text"} title={"Qualification"} inputChange={inputChange} currentValue={evaluation["Qualification"]} />
              </Box>
            </FormGroup>
            <FormGroup>
              <Box display="grid" paddingTop={2} justifyContent="center">
                <Information number={6} question={"Desired Level"} type={"text"} title={"Desired Level"} inputChange={inputChange} currentValue={evaluation["Desired Level"]} />
              </Box>
            </FormGroup>
            <FormGroup>
              <Box display="grid" paddingTop={2} width="500" justifyContent="center">
                <Information number={7} question={"Personality Type (MBTI)"} type={"text"} title={"Personality Type"} inputChange={inputChange} currentValue={evaluation["Personality Type"]} />
              </Box>
            </FormGroup>
            <FormGroup>
              <Box display="grid" paddingTop={2} marginBottom={5} justifyContent="center">
                <Button 
                  size="large" variant="contained" color="primary" 
                  disabled={((evaluation["Name"] !== "" && 
                  evaluation["Surname"] !== "" && 
                  !emailErrorCheck && 
                  evaluation["Age"] !== "" && 
                  evaluation["Gender"] !== "" && 
                  evaluation["Qualification"] !== "" && 
                  evaluation["Desired Level"] !== "")?false:true)} 
                  onClick={onNext}>
                    Start Questionnaire
                </Button>
              </Box>
            </FormGroup>
          </Box>
        </div>
      </div>
    </section>
  );
};

export default LandingPage;
